import React, { useContext, useState,useEffect } from 'react';
import Navbar from '../layouts/navbar';
import { AuthContext } from '../../auth';
import Parse, { User } from 'parse';
import swal from 'sweetalert';
import {withRouter} from 'react-router-dom'



const UserProfile = (props) => {

    useEffect(() => {
        const UserProfile = Parse.Object.extend("UserProfile");
        const query = new Parse.Query(UserProfile);
        query.equalTo('user_id',logedinuser).find().then(user=>{
            console.log(user);
            if(user.length===1){
                let id=user[0].get('chatid');
                console.log("user directed to chat page");
                props.history.replace(`/counsellorchat/${id}`);
                
            }

        },(error)=>{
            console.log(error);
            swal("Oops!", "Seems like there is some problem Please try again later", "error");
            props.history.replace('/');
        }) 
        
    }, [])


    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    const [relationship, setRelationship] = useState('');
    const [substances, setSubstances] = useState('');
    const [usagetime, setUsagetime] = useState('');
    const [frequency, setFrequency] = useState('');
    const [treatment, setTreatment] = useState('');
    const [complaint, setComplaint] = useState('');




    const submitHandler = (event) => {
        event.preventDefault();
        console.log(relationship);
        console.log(substances);
        console.log(usagetime);
        console.log(frequency);
        console.log(treatment);
        console.log(complaint);

        const UserProfile = Parse.Object.extend("UserProfile");
        const userprofile = new UserProfile();

        userprofile.set("relationship", relationship);
        userprofile.set("substances", substances);
        userprofile.set("usagetime", usagetime);
        userprofile.set("frequency", frequency);
        userprofile.set("treatment", treatment);
        userprofile.set("complaint", complaint);
        userprofile.set("user_id",logedinuser);


        const User = Parse.Object.extend("User");
        const query = new Parse.Query(User);
        query.get(logedinuser)
            .then((user) => {
                console.log(user);
                const chatid = user.get("counsellor").concat(logedinuser)
                userprofile.set("counsellor_id",user.get("counsellor"));
                userprofile.set("chatid",chatid);

                userprofile.save()
                    .then(data => {
                        setRelationship('');
                        setSubstances('');
                        setUsagetime('');
                        setFrequency('');
                        setTreatment('');
                        setComplaint('');
                        swal("Added!", "Your Profile has been created", "success");
                        props.history.replace(`/counsellorchat/${chatid}`);
                    })
                    .catch(error=>{
                        console.log(error);
                        swal("Oops!", "Seems like there is some problem Please try again later", "error");
                    })
            }, (error) => {
                console.log(error);
                swal("Oops!", "Seems like there is some problem Please try again later", "error");
            })

           
    }

    // },[])
    return (
    
        <div>
            

            <Navbar head="User Profile" />
            <div className="container" style={{ marginTop: "60px" }}>
                <form onSubmit={submitHandler}>
                    <div className="form-group">
                        <label htmlFor="relationship">1. What is your relation with the dependant?</label>
                        <select id="relationship" className="form-control w-50" onChange={e => setRelationship(e.target.value)} value={relationship} required>
                            <option value="">Choose</option>
                            <option>Dependant</option>
                            <option>Parent</option>
                            <option>Child</option>
                            <option>Cousin</option>
                            <option>Friend</option>
                            <option>Sibling</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="substances">2. What is/are the substances of their choice?</label>
                        <textarea className="form-control" id="substances" rows="3" onChange={e => setSubstances(e.target.value)} value={substances} required></textarea>
                    </div>
                    <div className="form-group">
                        <label htmlFor="usagetime">3. How long has their indulgence in the substance been?</label>
                        <input type="text" id="usagetime" className="form-control text-left" onChange={e => setUsagetime(e.target.value)} value={usagetime} required />


                    </div>
                    <div className="form-group">
                        <label htmlFor="frequency">4.What is the frequency of their use?</label>
                        <select id="frequency" className="form-control w-50" onChange={e => {setFrequency(e.target.value)}} value={frequency} required>
                            <option value="">Choose</option>
                            <option>More than once a day</option>
                            <option>Once a day- Once a week</option>
                            <option>More than once a week</option>
                            <option>Every 15 to 20 days</option>
                            <option>Monthly</option>
                            <option>Ocassionally</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="treatment">5. Have they sought treatment before?</label>
                        <select id="treatment" className="form-control w-50" value={treatment} onChange={e => setTreatment(e.target.value)} required>
                            <option value="">Choose</option>
                            <option>Yes</option>
                            <option>No</option>

                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="complaint">6.What is your presenting complaint?</label>
                        <textarea className="form-control" id="complaint" rows="3" onChange={e => setComplaint(e.target.value)} value={complaint} required></textarea>
                    </div>
                    <div className="form-row justify-content-center">
                        <button type="submit" className="submit btn-primary text-center">Submit</button>
                    </div>
                </form>
            </div>

        </div>
    )
}

export default withRouter(UserProfile);